module.exports = __webpack_public_path__ + "al.no2.4272b670.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/al.no2.jpg
// module id = 89sp
// module chunks = 0